import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntdApp, theme as antdTheme } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorPrimary: '#0ea5e9',
          colorInfo: '#06b6d4',
          colorSuccess: '#22c55e',
          colorWarning: '#f59e0b',
          colorError: '#ef4444',
          colorText: '#f8fafc',
          colorTextSecondary: 'rgba(226,232,240,.74)',
          colorTextTertiary: 'rgba(203,213,225,.52)',
          colorBgBase: '#05070d',
          colorBgContainer: 'rgba(15,23,42,.72)',
          colorBgElevated: 'rgba(17,24,39,.94)',
          colorBorder: 'rgba(255,255,255,.12)',
          borderRadius: 16,
          borderRadiusLG: 24,
          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        },
        components: {
          Layout: { bodyBg: 'transparent', headerBg: 'transparent', siderBg: 'transparent' },
          Menu: { itemBg: 'transparent', subMenuItemBg: 'transparent', itemSelectedBg: 'rgba(14,165,233,.18)', itemSelectedColor: '#93c5fd' },
          Button: { borderRadius: 999, controlHeight: 36 },
          Card: { borderRadiusLG: 24, colorBorderSecondary: 'rgba(170,205,255,.12)' },
          Modal: { borderRadiusLG: 24 },
          Drawer: { colorBgElevated: 'rgba(17,24,39,.94)' },
        },
      }}
    >
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  </React.StrictMode>,
);
